import {createAction} from '@reduxjs/toolkit';
import {LegacyAddressStatus} from '../AddressStatus';
import {UserStatus} from '../UserStatus';

export const userinfoRoutine = (type => ({
    aborted: createAction(`${type}/ABORTED`),
    trigger: createAction(`${type}/TRIGGER`),
    success: createAction(
        `${type}/SUCCESS`,
        (payload: {userStatus: UserStatus; addressStatus: LegacyAddressStatus}) => ({payload})
    ),
    failure: createAction(`${type}/FAILURE`, (err: unknown) => ({payload: err})),
}))('USERINFO_DETAILS' as const);
